import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../redux/store/rootReducer';
import { Table, Input, Button, Popconfirm } from 'antd';
import { useEffect, useState } from 'react';
import React from 'react';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import { updateSts } from '../bodySize/bodySizeSlice';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { removeConnectionConversion } from './conectionConversionSlice';

export default function ConnectionConversionPageList(): JSX.Element {
  const dispatch = useDispatch();
  const { setModelChange, messageApi, setEditBodySize } = React.useContext(CommonContext) as CommonContextType;
  const ConnectionConversion = useSelector(
    (state: AppState) => state.ConnectionConversions
  );

  useEffect(() => {
    if (ConnectionConversion.success.sts == true) {
      messageApi.open({
        type: 'success',
        content: ConnectionConversion.success.data,
      });

      dispatch(updateSts({}));
    } else if (ConnectionConversion.success.sts == false) {
      messageApi.open({
        type: 'error',
        content: ConnectionConversion.success.data,
      });

      dispatch(updateSts({}));
    }

  }, [ConnectionConversion])

  const showModal = (record?: any) => {
    if (record.id) {
      setEditBodySize(record)
      setModelChange(true)
    }
  };
  const handleDelete = (id: number) => {
    dispatch(removeConnectionConversion(id));
  };

  const [searchText, setSearchText] = useState('');

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value.toLowerCase());
  };

  const dataArray = ConnectionConversion.ConnectionConversion || [];
  console.log(ConnectionConversion)

  const filteredData = dataArray.filter((item: any) =>
    Object.values(item).some((value) =>
      value?.toString().toLowerCase().includes(searchText)
    )
  );

  const columns = [
    {
      title: 'Designation',
      dataIndex: 'designation',
      key: 'designation'
    },
    {
      title: 'Part Number',
      dataIndex: 'part_number',
      key: 'part_number'
    },
    {
      title: 'Created On',
      dataIndex: 'created_datetime',
      key: 'created_datetime'
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (text: any, record: any) => (
        <>
          <Button
            type="link"
            icon={<EditOutlined style={{ color: '#018B98' }} />}
            onClick={() => showModal(record)}
          >
          </Button>
          <Popconfirm
            title="Are you sure to delete this item?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger icon={<DeleteOutlined style={{ color: 'red' }} />}>
            </Button>
          </Popconfirm>
        </>
      )
    }
  ];

  return (
    <>
      {dataArray.length > 0 ? (
        <>
          <Input
            placeholder="Search in table..."
            onChange={handleSearch}
            style={{ marginBottom: 16, width: 300 }}
          />
          <Table dataSource={filteredData} columns={columns} rowKey="id" />
        </>
      ) : (
        <p style={{ textAlign: "center", marginTop: 16 }}>No data available</p>
      )}
    </>
  );

}
